export const logAndError = (message: string): Error => {
  console.error(message);
  return new Error(message);
};

export function logInvariant(
  condition: any,
  message: string,
): asserts condition {
  if (!condition) {
    throw logAndError(message);
  }
}

export const getStrFormValue = (form: FormData, param: string): string => {
  const formValue = form.get(param);
  logInvariant(formValue, `form value "${param}" is required`);
  if (typeof formValue === "string") {
    return formValue;
  }
  throw logAndError(`${param} in form value must be a string`);
};

export const getOptionalStrFormValue = (
  form: FormData,
  param: string,
): string | undefined => {
  const formValue = form.get(param);

  if (formValue == null) {
    // Not included in form so return undefined
    return undefined;
  }

  if (typeof formValue === "string") {
    return formValue;
  }

  throw logAndError(`${param} in form value must be a string`);
};

// Undefined means wasn't in form
// Otherwise parse json as a null string and return
export const getOptionalJSONNullStrFormValue = (
  form: FormData,
  param: string,
): string | null | undefined => {
  const formValue = form.get(param);

  if (formValue == null) {
    // Not included in form so return undefined
    return undefined;
  }

  if (typeof formValue === "string") {
    const parsed = JSON.parse(formValue);
    if (parsed == null) {
      // JSON parsed to null so return null
      return null;
    }
    if (typeof parsed === "string") {
      // JSON parsed is string so return
      return parsed;
    }
  }

  throw logAndError(`${param} in form value must be json of a null string`);
};

export const getJsonFormValue = (form: FormData, param: string) => {
  const strValue = getStrFormValue(form, param);
  return JSON.parse(strValue);
};

export const getOptionalJsonFormValue = (form: FormData, param: string) => {
  const strValue = getOptionalStrFormValue(form, param);

  if (strValue === undefined) {
    return null;
  }

  return JSON.parse(strValue);
};

export const getNumberFormValue = (form: FormData, param: string): number => {
  const strValue = getStrFormValue(form, param);
  const num = +strValue;
  if (isNaN(num) || strValue === "") {
    throw logAndError(`${param} in form value must be a valid number`);
  }
  return num;
};

export const getOptionalBoolFormValue = (
  form: FormData,
  param: string,
): boolean | null => {
  const formValue = form.get(param);
  if (formValue == null) {
    return null;
  }
  if (typeof formValue !== "string") {
    throw logAndError(`${param} in form value must be a string`);
  }
  const lcValue = formValue.toLowerCase();
  if (lcValue === "true") {
    return true;
  } else if (lcValue === "false") {
    return false;
  }
  throw logAndError(
    `${param} in form value must be either true or false, not ${formValue}`,
  );
};
